export default "__VITE_ASSET__9Sa8A$u4__"